import React from 'react';
import IntegrationSettingsUseCases from './IntegrationSettingsUseCases';
import LegalHold from './LegalHold';
import PreventLanguages from './PreventLanguages';
import RetentionPeriod from './RetentionPeriod';
import RetentionPolicy from './RetentionPolicy';
import TranslationsNeeded from './TranslationsNeeded';
import TranslationsPrevent from './TranslationsPrevent';

const EditIntegrationMainContent: React.FC = () => (
  <div className="w-3/5 min-w-136 pr-10 h-full flex flex-col gap-1 text-body bg-white">
    <div className="h-full flex flex-col gap-10">
      <span>Workspace selections</span>

      <div className="h-full flex flex-col gap-8">
        <div className="flex flex-col gap-4">
          <LegalHold />
          <RetentionPolicy />
          <RetentionPeriod />
        </div>
        <IntegrationSettingsUseCases />
        <div className="flex flex-col gap-6">
          <TranslationsNeeded />
          <TranslationsPrevent />
          <PreventLanguages />
        </div>
      </div>
    </div>
  </div>
);

export default EditIntegrationMainContent;
